module.exports = __webpack_public_path__ + "img/radarImg.034de63c.svg";